export enum AuthorizationRequestFields {
    Mail = 'mail',
    Password = 'password',
    ClientIp = 'ipClient'
}

export interface AuthorizationRequest {
    [AuthorizationRequestFields.Mail]: string
    [AuthorizationRequestFields.Password]: string
    [AuthorizationRequestFields.ClientIp]: string
}

export enum AuthorizationResponseFields {
    UserId = 'idUsuario',
    ProfileIds = 'idsPerfil',
    Lastname = 'apellidoNombre',
    GroupIds = 'idsGrupo',
    PersonRoleId = 'idRolPersona',
    PasswordChangeDaysRemaining = 'cantDiasParaCambiarPass',
    DefaultLanguage = 'idiomaDefault',
    IsBankGroup = 'esGrupoBanco',
    IsInternalGroup = 'esGrupoInterno',
    AuthToken = 'accessToken',
    HasError = 'tieneError',
    ErrorDescription = 'descripcionError',
    IsAdmin = 'bitAdministrador',
    CodCargo = 'tinCodUsuarioCargo',
    Cargo = 'vchDescUsuarioCargo',
    CanCreateNewMessage = 'bitPermiteCargarOperaciones',
    Mail = 'mail',
}

export interface AuthorizationResponse {
    [AuthorizationResponseFields.UserId]: number
    [AuthorizationResponseFields.ProfileIds]: string
    [AuthorizationResponseFields.Lastname]: string
    [AuthorizationResponseFields.GroupIds]: string
    [AuthorizationResponseFields.PersonRoleId]: number | null
    [AuthorizationResponseFields.PasswordChangeDaysRemaining]: number
    [AuthorizationResponseFields.DefaultLanguage]: string
    [AuthorizationResponseFields.IsBankGroup]: boolean
    [AuthorizationResponseFields.IsInternalGroup]: boolean
    [AuthorizationResponseFields.AuthToken]: string
    [AuthorizationResponseFields.HasError]: boolean
    [AuthorizationResponseFields.ErrorDescription]: string
    [AuthorizationResponseFields.IsAdmin]: boolean
    [AuthorizationResponseFields.CodCargo]: number
    [AuthorizationResponseFields.Cargo]: string
    [AuthorizationResponseFields.CanCreateNewMessage]: boolean
    [AuthorizationResponseFields.AuthToken]: string,
    [AuthorizationResponseFields.Mail]: string
}


export enum GoogleAuthFields {
    Token = 'token'
}

export interface GoogleAuthorizationRequest {
    [GoogleAuthFields.Token]: string
}
